import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import { TenantPage } from 'layouts';
import { uniqueId } from 'lodash';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { invoiceService } from 'shared/services';
import toast from 'shared/utils/toast';
import InvoiceCreateDialog from '../components/dialog/InvoiceCreateDialog';
import { AddButton } from 'components/ui';
import { InvoiceColumns } from '../invoices';

const TRANSLATION_PREFIX = 'pages.invoices.list';

const INITIAL_FILTERS = [
  {
    // id: uniqueId(),
    // field: 'closed',
    // operator: 'is',
    // value: 'false'
  }
];

const INITIAL_PARAMS = {
  // closed: 'false'
};

export const Invoices = () => {
  const { t } = useTranslation();
  const dataGridRefreshRef = useRef(null);

  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);

  const handleOpenCreateDialog = () => {
    setIsCreateDialogOpen(true);
  };

  const handleCloseCreateDialog = () => {
    setIsCreateDialogOpen(false);
  };

  const handleCreateSubmit = async (values: any) => {
    try {
      await invoiceService.add(values);
      toast.crud.successCreate('Fattura', 'f');
      dataGridRefreshRef.current?.();
    } catch (error) {
      toast.crud.errorCreate('Fattura');
      console.error('Failed to create invoice:', error);
    } finally {
      setIsCreateDialogOpen(false);
    }
  };

  const columns = InvoiceColumns(dataGridRefreshRef.current);

  return (
    <TenantPage
      title={t(`${TRANSLATION_PREFIX}.title`)}
      subtitle={t(`${TRANSLATION_PREFIX}.subtitle`)}
      pageType="invoices"
      menuRight={<AddButton onClick={handleOpenCreateDialog} prefix={TRANSLATION_PREFIX} />}>
      <EnhancedDataGrid
        columns={columns}
        // initialFilterItems={INITIAL_FILTERS}
        // initialParams={INITIAL_PARAMS}
        service={invoiceService}
        refresh={dataGridRefreshRef}
      />
      <InvoiceCreateDialog
        isOpen={isCreateDialogOpen}
        onClose={handleCloseCreateDialog}
        onSubmit={handleCreateSubmit}
      />
    </TenantPage>
  );
};
